import React from 'react';

export default function ReportingManagerControl({ employeeName, managerName, onChange, compact = false }) {
  const manager = managerName || 'No direct manager';
  return (
    <button type="button" className={`org-manager-control${compact ? ' compact' : ''}`}
      aria-label={`Change reporting manager for ${employeeName}. Current: ${manager}`}
      title={`Reporting manager: ${manager}. Click to change.`}
      onClick={event => { event.stopPropagation(); onChange(); }}>
      <span className="org-manager-label">Manager</span>
      <span className="org-manager-name">{manager}</span>
      <svg className="org-manager-edit" aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="m16 3 5 5M4 20l4-1L21 6a2.1 2.1 0 0 0-3-3L5 16l-1 4Z" />
      </svg>
    </button>
  );
}
